import React, { useEffect, useState } from 'react';
import { AjaxError, AjaxResponse } from 'rxjs/ajax';
import { fetchPost, getDefaultHeaders, post } from '__utils/ajax-wrapper';
import { useMediaQuery } from 'react-responsive';
import styled from 'styled-components';
import { COLOR } from 'constants/colors';
import ProgressSteps from 'components/progress-steps';
import download from "images/download.svg";
import { ENDPOINTS } from 'constants/endpoints';
import { mixpanelTrack } from './verify-mandate';
import resolveURLParams from '__utils/url-params-resolver';
import useFlashToggler from 'hooks/use-flash-toggler';
import FileUpload from 'components/file-upload';
import { UploadIcon } from '../../../assets/icons/upload-icon';
import { getQueryParamsFromString, isMintproApp } from '__utils/common-utils';
import disclaimerIcon from "../../../images/phycialMandateDisclaimerIcon.svg";

interface PhysicalMandateProps {
    mandateLimitAmount: any;
    onMandateScanUpload: Function;
}
const PhysicalMandate: React.FC<PhysicalMandateProps> = ({ mandateLimitAmount, onMandateScanUpload }: PhysicalMandateProps) => {

    const flash = useFlashToggler();
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const { mandateId,mandateLimit } = getQueryParamsFromString(window.location.search);
    const [xMandateAvailable, setXmandateAvailable] = useState<boolean>(mandateId ? true : false);
    const [mandateScanUploaded, setMandateScanUploaded] = useState<boolean>(false);
    const [mandateURL, setMandateURL] = useState<any>("");
    const [tiffFileName, setTiffFileName] = useState<string>();
    const [decMandateId, setDecMandateId] = useState<any>();
    const [decMandateLimit, setDecMandateLimit] = useState<any>();

    const PhysicalMandateContainer = styled.div<any>`
        .previewBrd {
            border: 5px solid ${COLOR.LIGHTGREY};
            border-radius: 4px;
            text-align: center;
            background: ${COLOR.LIGHTGREY};
            position: relative;
            width: ${props => (props.isMobile ? '' : '328px')};
            height: 248px;
        }
        .txtReplace{
            position: absolute!important;
            background: #e0e0e0;
            left: 0px;
            bottom: 0px;
            width: ${props => (props.isMobile ? '100%' : '320px')};
            padding: 7px;
        }
`;


    useEffect(()=>{
        mandateId && setDecMandateId(window.atob(mandateId))
    },[mandateId]);

    useEffect(()=>{
        mandateLimit && setDecMandateLimit(window.atob(mandateLimit))
    },[mandateLimit]);

    //@purpose: download x-mandate
    const downloadXMandate = () => {
        mixpanelTrack('physicalMandateDownload', 'clicked');
        post(resolveURLParams(ENDPOINTS.POST_DOWNLOAD_PHYSICAL_MANDATE_FORM, { mandateAmount:decMandateLimit? decMandateLimit : mandateLimitAmount, mandateId:decMandateId? decMandateId : ''  }, {}), null, getDefaultHeaders(), true)
            .subscribe((response: AjaxResponse | AjaxError) => {
                if (response.response?.data && response.response.meta.message === "success") {
                    const result = response.response?.data;
                    if (isMobile && isMintproApp()) {
                        var featurePayload = {
                            type: 'download',
                            payload: {
                                fileName: result?.fileName,
                                fileUrl: result?.fileUrl,
                                fileType: result?.fileType,
                            },
                        };
                        window.postMessage(JSON.stringify(featurePayload), '*');
                    }
                    else {
                        window.open(result?.fileUrl, '_blank', 'noopener')?.focus();
                    }
                    setXmandateAvailable(true);
                }
                else if (response.response.meta.message === "failure" && response.response?.data) flash.error(response.response?.data);
                else flash.error("Failed to download mandate. Please try again later")

            }, (error: AjaxError) => {
                flash.error("Failed to download mandate. Please try again later")
            })
    }

    //@purpose: check for size validity of image
    const onXMandateUpload = (xMandateFile: any) => {
        if (xMandateFile && xMandateFile.size < 2e+6) {
            if (xMandateFile.type === "image/tiff") {
                setTiffFileName(xMandateFile.name);
            }
            uploadMandateScanFile(xMandateFile);
        }
        else flash.error("Please upload file with size less than 2MB.")
    }


    const uploadMandateScanFile = (xMandateFile: any) => {
        mixpanelTrack('physicalMandateUpload', 'clicked')
        const formData = new FormData();
        formData.append('file', xMandateFile);
        fetchPost(
            `${ENDPOINTS.POST_UPLOAD__MANDATE}?mandateId=${decMandateId?decMandateId: ''}`, formData, null, true
        ).then((response: any) => {
            if (response.data && response.meta.message === "success") {
                setMandateScanUploaded(true);
                setMandateURL(response?.data?.value);
                onMandateScanUpload(true);
            }
            else {
                flash.error("Failed to upload. Please try again later.");
            }
        }).catch((error: any) => {
            flash.error("Failed to upload. Please try again later.");
        })
    }

    return (
        <PhysicalMandateContainer isMobile={isMobile}>
            <div>
                <p className='questionFont'>Follow 3 steps</p>
                <div className='mandateMargin'>
                    <ProgressSteps stepsObject={[
                        {
                            title: 'Step 1',
                            description: <div>
                                <p>Download prefilled mandate form</p>
                                <div className='dwnldDiv' onClick={downloadXMandate}>
                                    <img src={download} alt="download" /> <span className='greenBoldText'>&nbsp;Download Form</span>
                                </div>
                            </div>
                        },
                        {
                            title: 'Step 2',
                            description: <div>
                                <p>Print & sign the form.</p>

                            </div>
                        },
                        {
                            title: 'Step 3',
                            description: <div>
                                <p>Scan or take picture of signed form & upload it.The file should be less than 2mb in .jpeg or .tiff format.</p>
                                <div className={xMandateAvailable||mandateId?'dwnldDiv':'dwnldDivDisabled'}>
                                    <FileUpload
                                        name="xMandate"
                                        className='uploadImgCls'
                                        id="xMandateImgFile"
                                        accept="image/tiff, image/jpeg, image/jpg"
                                        showAfterUpload
                                        isUploaded={mandateScanUploaded}
                                        onPictureUpload={onXMandateUpload}
                                        disabled={!xMandateAvailable}
                                    >
                                        <UploadIcon enabled={mandateId||xMandateAvailable} /> <span className={mandateId||xMandateAvailable?'greenBoldText':'greyBoldText'}> &nbsp;Upload Form</span>
                                    </FileUpload>

                                </div>

                                { decMandateId ? <div className={mandateURL ? 'hide' : "pendingMandateDisclaimer"}> 
                                    <img src={disclaimerIcon} alt="physical mandate discalimer icon" />
                                    <p><span>Pending</span><br />
                                        Before uploading, kindly make sure the mandate ID on your form matches the mandate ID of this order. If a wrong ID is uploaded, this order will be cancelled.
                                    </p>
                                </div> : null }
                            </div>
                        }
                    ]} />
                </div>
                {mandateURL && <div className='mandate-step'>
                    {
                        tiffFileName ? <div>Uploaded file : {tiffFileName}</div> :
                            <div className='previewBrd'>
                                <img src={mandateURL} alt='xmandate' />
                                <span className="greenTxt txtReplace" onClick={() => { (document.getElementById('xMandateImgFile') as HTMLInputElement).click() }}>Replace photo</span>
                            </div>
                    }
                </div>}
                <br />
            </div>
        </PhysicalMandateContainer>
    )
}

export default PhysicalMandate


